// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_abbd05d","regulatoryText":"_7f64048","eighteenPlusFrWrapper":"_051c08b","eighteenPlusFr":"_6c12414","logoFr":"_86b30d9"};